<script lang="ts">
  import data from "../../../../Data/Ecommerce/Ecommerce.json"
  import Link from "svelte-link";
  import { href } from "../../../../utils/Constant/Constant";
  import {classId} from "../../../../store"
  // for layout view
  const handleGrid = (id:number) =>{
    classId.update(value => value = id)
  }
</script>
<div class="grid-options d-inline-block">
    <ul>
        {#each data.productfilterdata as productItem}
            <li>
                <Link
                    class="product-2-layout-view"
                    href={href}
                    on:click={()=>handleGrid(productItem.id)}>
                    {#each productItem.filterdata as lineItem}
                        <span class="line-grid line-grid-{lineItem.class} bg-primary" />
                    {/each}
                </Link>
            </li>
        {/each} 
    </ul>
</div>